/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_Happy_ListenersInputs */

const en_marketing_app_happy_listeners = /** @type {(inputs: Marketing_App_Happy_ListenersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`happy listeners`)
};

const es_marketing_app_happy_listeners = /** @type {(inputs: Marketing_App_Happy_ListenersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oyentes felices`)
};

/**
* | output |
* | --- |
* | "happy listeners" |
*
* @param {Marketing_App_Happy_ListenersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_happy_listeners = /** @type {((inputs?: Marketing_App_Happy_ListenersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_Happy_ListenersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_happy_listeners(inputs)
	return en_marketing_app_happy_listeners(inputs)
});